import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=4d500a46&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"
import style0 from "./Permisos.vue?vue&type=style&index=0&id=4d500a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d500a46",
  null
  
)

export default component.exports